import React from "react";

interface BoxSwarmToggleProps {
  isBoxplotInFront: boolean;
  setIsBoxplotInFront: (value: boolean) => void;
}

export const BoxSwarmToggle = ({
  isBoxplotInFront,
  setIsBoxplotInFront,
}: BoxSwarmToggleProps) => {
  return (
    <div className="flex justify-between items-center   text-[12px] ">
      <button
        data-testid="plot-box-swarm-toggle-box"
        className={`${
          isBoxplotInFront ? selectedClasses : notSelectedClasses(false)
        } px-2 rounded-tl-md rounded-bl-md h-[28px]`}
        onClick={() => setIsBoxplotInFront(true)}
      >
        Box
      </button>
      <button
        data-testid="plot-box-swarm-toggle-swarm"
        className={`${
          isBoxplotInFront ? notSelectedClasses(true) : selectedClasses
        } px-2 rounded-tr-md rounded-br-md h-[28px]`}
        onClick={() => setIsBoxplotInFront(false)}
      >
        Swarm
      </button>
    </div>
  );
};

const selectedClasses = "bg-[#ECFAFF] border border-[#58A6C6]";
const notSelectedClasses = (swarmToggle: boolean) =>
  `bg-[#FFF] border border-[#E5E5E5] ${
    swarmToggle ? "border-l-0" : "border-r-0"
  }`;
